export default "__VITE_ASSET__CzXxhiq4__"